import { render, staticRenderFns } from "./AdminUsecases.vue?vue&type=template&id=b61d66ea&scoped=true"
import script from "./AdminUsecases.vue?vue&type=script&lang=js"
export * from "./AdminUsecases.vue?vue&type=script&lang=js"
import style0 from "./AdminUsecases.vue?vue&type=style&index=0&id=b61d66ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61d66ea",
  null
  
)

export default component.exports